<div class="report-problem-container">
  <div class="report-problem-nav-bar box">
    <div class="report-problem-nav-bar-title">گزارش مشکل</div>
    <div class="report-problem-back" (click)="back()">
      <img src="assets/general/back-blue.svg" />
    </div>
    <div class="report-problem-send" (click)="send()">ارسال</div>
  </div>
  <div class="report-problem-holder">
    <textarea
      [(ngModel)]="problem"
      rows="1"
      (ngModelChange)="autoGrow()"
      id="textarea"
      maxlength="2000"
      placeholder="مشکل یا نظر خود را بنویسید..."
    ></textarea>
  </div>
</div>
